import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useTrackPageView } from '@grandvisionhq/svc-tealium/events';
import { bookAppointmentWhereStepScreenEvent } from '../../data-layer/actions.js';
import { useAppointmentContext } from '../../pages/BookAppointment/context/AppointmentContext.js';
import { useRoutingContext } from '../../pages/BookAppointment/context/RoutingContext/context.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/state';
import '@grandvisionhq/utils';
import '../../pages/BookAppointment/queries/get-book-appointment-store-by-id.js';
import '../../pages/BookAppointment/queries/get-book-appointment-type.js';
import '@grandvisionhq/bloomreach';
import useBookAppointmentTypeWithUrlParam from '../../pages/BookAppointment/hooks/use-book-appointment-type-with-url-param.js';
import AppointmentLocation from './AppointmentLocation.js';

const AppointmentLocationContainer = (props)=>{
    const [{ setStore , setType , setTimeSlot  }, { store , type , timeSlot  }] = useAppointmentContext();
    const [, { queryParams  }] = useRoutingContext();
    /** Refetch appointment type data if has different typeId appointment type id in the context.
   * This can be possible when user use back and forth browser button to navigate between steps */ useBookAppointmentTypeWithUrlParam();
    const aabWherePageView = React.useCallback(()=>Promise.resolve({
            id: 'VirtualPage-View',
            Page_Type: 'FindStore',
            Page_Section1: 'Exam'
        })
    , []);
    useTrackPageView(aabWherePageView);
    React.useEffect(()=>{
        if (store && !queryParams.storeId) {
            setStore(null);
        }
        if (type && !queryParams.typeId) {
            setType(null);
        }
        if (timeSlot && (!queryParams.start || !queryParams.end)) {
            setTimeSlot(null);
        }
    }, [
        queryParams,
        setStore,
        setType,
        setTimeSlot,
        store,
        type,
        timeSlot
    ]);
    React.useEffect(()=>{
        const dataLayerEvent = bookAppointmentWhereStepScreenEvent();
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    return /*#__PURE__*/ React.createElement(AppointmentLocation, swcHelpers.extends({}, props));
};

export { AppointmentLocationContainer as default };
//# sourceMappingURL=AppointmentLocationContainer.js.map
